import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=21f5c532&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=21f5c532&scoped=true&lang=scss&"
import style1 from "./Home.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5c532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f5c532')) {
      api.createRecord('21f5c532', component.options)
    } else {
      api.reload('21f5c532', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=21f5c532&scoped=true&", function () {
      api.rerender('21f5c532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vendors/Home.vue"
export default component.exports